import React, { CSSProperties } from "react";
import Button from "@mui/material/Button";
import { SxProps } from "@mui/material";
import { color } from "d3";
import { LineDashedMaterial } from "three";
import { LineWeight } from "@mui/icons-material";

interface Props {
  children?: React.ReactNode;
  disabled?: boolean;
  width?: string;
  color?: string;
  style?: SxProps;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  cancel?: boolean;
  danger?: boolean;
}

const SearchButton: React.FC<Props> = ({
  onClick,
  children,
  disabled,
  width,
  color,
  style,
  cancel,
  danger,
}) => {
  return (
    <Button
      sx={[
        {
          color: "white",
          backgroundColor: "transparent",
          height: 42,
          minWidth: width ?? 130,
          marginBottom: 2,
          lineHeight: "18px",
          boxShadow: "16px 16px 20px 0 rgba(0, 0, 0, 0.16)",
          border: "solid 2px",
          borderColor: color ?? "primary.main",
          borderRadius: "11px",
          borderTop: "0px",
          borderRight: "0px",
          borderLeft: "0px",
          fontSize: "16px",
          pl: "10px",
          pr: "10px",
          "&:hover": {
            backgroundColor: "#2A2537",
          },
        },
        style ? style : {},
      ].flat(2)}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};

export default SearchButton;
